import { UpNextStore } from './schema/UpNextStore';
import { ObservableMap } from 'mobx';
import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import { createStore } from 'satcheljs';

const upNextDefaultStore: UpNextStore = {
    calendarItems: new ObservableMap<string, CalendarItem>({}), // The meetings for the next 2 days.
    nextMeetingInformation: null,
};

export let getStore = createStore<UpNextStore>('upNext', upNextDefaultStore);
const upNextStore = getStore();

export default upNextStore;
